import {ActiveUsersResponse} from './responses/ActiveUsersResponse';
import {AppOAuth2CredentialsResponse} from './responses/AppOAuth2CredentialsResponse';
import {AppOAuth2ListCredentialsResponse} from './responses/AppOAuth2ListCredentialsResponse';
import {AppOauth2AccessTokenResponse} from './responses/AppOauth2AccessTokenResponse';
import {BaseResponse} from './responses/BaseResponse';
import {BasesResponse} from './responses/BasesResponse';
import {BillingBooleanResponse} from './responses/BillingBooleanResponse';
import {BooleanResponse} from './responses/BooleanResponse';
import {CNameMappingResponse} from './responses/CNameMappingResponse';
import {CheckAuthResponse} from './responses/CheckAuthResponse';
import {CheckInviteCodeResponse} from './responses/CheckInviteCodeResponse';
import {CheckResponse} from './responses/CheckResponse';
import {CloudArtifactsResponse} from './responses/CloudArtifactsResponse';
import {ComputePipeResponse} from './responses/ComputePipeResponse';
import {DeleteInvitationResult} from './responses/DeleteInvitationResult';
import {DeployResult} from './responses/DeployResult';
import {Design} from './responses/Design';
import {DesignResponse} from './responses/DesignResponse';
import {DesignScreenshotResponse} from './responses/DesignScreenshotResponse';
import {DesignSnapshotResponse} from './responses/DesignSnapshotResponse';
import {DesignSnapshotsResponse} from './responses/DesignSnapshotsResponse';
import {DesignWithTimestampsResponse} from './responses/DesignWithTimestampsResponse';
import {DesignsResponse} from './responses/DesignsResponse';
import {EmbedSnippetResponse} from './responses/EmbedSnippetResponse';
import {EmbedSnippetsResponse} from './responses/EmbedSnippetsResponse';
import {ExtendedTeamsResponse} from './responses/ExtendedTeamsResponse';
import {ExtendedUserGroupsResponse} from './responses/ExtendedUserGroupsResponse';
import {FeaturesResponse} from './responses/FeaturesResponse';
import {FileResponse} from './responses/FileResponse';
import {FilesResponse} from './responses/FilesResponse';
import {FindUsersResponse} from './responses/FindUsersResponse';
import {FunctionSaveResponse} from './responses/FunctionSaveResponse';
import {FunctionUpdateResponse} from './responses/FunctionUpdateResponse';
import {FunctionsResponse} from './responses/FunctionsResponse';
import {GenerateResponse} from './responses/GenerateResponse';
import {GenerateSidResponse} from './responses/GenerateSidResponse';
import {GetComponentsResponse} from './responses/GetComponentsResponse';
import {GetDesignArtifactsResponse} from './responses/GetDesignArtifactsResponse';
import {GetPackagesResponse} from './responses/GetPackagesResponse';
import {InitEvent} from './responses/InitEvent';
import {InputStream} from './responses/InputStream';
import {InsightsResponse} from './responses/InsightsResponse';
import {InsightsTopologyView} from './responses/InsightsTopologyView';
import {InvitationDetailsResponse} from './responses/InvitationDetailsResponse';
import {InviteCreationResponse} from './responses/InviteCreationResponse';
import {InvoiceHistoryResponse} from './responses/InvoiceHistoryResponse';
import {LoadDesignResponse} from './responses/LoadDesignResponse';
import {MultiplayerResolution} from './responses/MultiplayerResolution';
import {MyRolesResponse} from './responses/MyRolesResponse';
import {OrganizationResponse} from './responses/OrganizationResponse';
import {OrganizationsResponse} from './responses/OrganizationsResponse';
import {ParsedTabsResponse} from './responses/ParsedTabsResponse';
import {PaymentMethodResponse} from './responses/PaymentMethodResponse';
import {PermissionsResponse} from './responses/PermissionsResponse';
import {ProductOffering} from './responses/ProductOffering';
import {ProfileResponse} from './responses/ProfileResponse';
import {ProjectResponse} from './responses/ProjectResponse';
import {ProjectRolesResponse} from './responses/ProjectRolesResponse';
import {ProjectUsersResponse} from './responses/ProjectUsersResponse';
import {ProjectsResponse} from './responses/ProjectsResponse';
import {PublishedApplicationResponse} from './responses/PublishedApplicationResponse';
import {PublishedDesignResponse} from './responses/PublishedDesignResponse';
import {PublishedDesignsResponse} from './responses/PublishedDesignsResponse';
import {ResolutionResponse} from './responses/ResolutionResponse';
import {Response} from './responses/Response';
import {RoleResponse} from './responses/RoleResponse';
import {RolesResponse} from './responses/RolesResponse';
import {RowsCountResponse} from './responses/RowsCountResponse';
import {RowsSelectResponse} from './responses/RowsSelectResponse';
import {S3BucketsResponse} from './responses/S3BucketsResponse';
import {S3UploadResponse} from './responses/S3UploadResponse';
import {SampleDesignResponse} from './responses/SampleDesignResponse';
import {SaveDesignResponse} from './responses/SaveDesignResponse';
import {SettingsEditResponse} from './responses/SettingsEditResponse';
import {SettingsMetaListResponse} from './responses/SettingsMetaListResponse';
import {SettingsResponse} from './responses/SettingsResponse';
import {SimulationResponse} from './responses/SimulationResponse';
import {StandardArtifactsResponse} from './responses/StandardArtifactsResponse';
import {StringResponse} from './responses/StringResponse';
import {SubscriptionResponse} from './responses/SubscriptionResponse';
import {SubscriptionsResponse} from './responses/SubscriptionsResponse';
import {SuggestUrlPartResponse} from './responses/SuggestUrlPartResponse';
import {TableResponse} from './responses/TableResponse';
import {TableSchemaResponse} from './responses/TableSchemaResponse';
import {TablesResponse} from './responses/TablesResponse';
import {TeamResponse} from './responses/TeamResponse';
import {TeamUsersResponse} from './responses/TeamUsersResponse';
import {TeamsResponse} from './responses/TeamsResponse';
import {TokenResponse} from './responses/TokenResponse';
import {TopologyIdResponse} from './responses/TopologyIdResponse';
import {UpdateAppStatusResponse} from './responses/UpdateAppStatusResponse';
import {UploadedFileResponse} from './responses/UploadedFileResponse';
import {UserGroupResponse} from './responses/UserGroupResponse';
import {UserGroupUsersResponse} from './responses/UserGroupUsersResponse';
import {UserGroupsResponse} from './responses/UserGroupsResponse';
import {UserResponse} from './responses/UserResponse';
import {UserWithTokenResponse} from './responses/UserWithTokenResponse';
import {UsersOfGroupsResponse} from './responses/UsersOfGroupsResponse';
import {ValidationResponse} from './responses/ValidationResponse';

import {Fetcher} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {EventSourceSubscriber} from '@mintdata-wsp/common/controllers/network/EventSourceSubscriber';

export type NoExpectedResponse = any;

export class StandardArtifacts
{
    constructor(private _http:Fetcher)
    {
    }

    getStandardArtifacts():Promise<StandardArtifactsResponse>
    {
        const __responseTypeCtor = StandardArtifactsResponse;
        const __apiPath = '/api/artifacts/standard/';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class AppOauth2
{
    constructor(private _http:Fetcher)
    {
    }

    callback(state:any, code:any):Promise<String>
    {
        const __responseTypeCtor:any = null;
        const __apiPath = '/api/app-oauth2/callback';
        const __params = {'state': state, 'code': code};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    revokeToken(authProvider:any, organizationSid:any, appName:any, appOauth2RevokeTokenRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/app-oauth2/' + authProvider + '/revoke/' + organizationSid + '/' + appName + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, appOauth2RevokeTokenRequest);
    }

    clientCredentials(authProvider:any, organizationSid:any, appName:any):Promise<AppOauth2AccessTokenResponse>
    {
        const __responseTypeCtor = AppOauth2AccessTokenResponse;
        const __apiPath = '/api/app-oauth2/' + authProvider + '/clientCredentials/' + organizationSid + '/' + appName + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    refreshToken(authProvider:any, organizationSid:any, appName:any, appOauth2RefreshTokenRequest:any):Promise<AppOauth2AccessTokenResponse>
    {
        const __responseTypeCtor = AppOauth2AccessTokenResponse;
        const __apiPath = '/api/app-oauth2/' + authProvider + '/refreshToken/' + organizationSid + '/' + appName + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, appOauth2RefreshTokenRequest);
    }
}

export class AppOauth2Credentials
{
    constructor(private _http:Fetcher)
    {
    }

    deleteAppCredentials(organizationSid:any, authProvider:any, appName:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/app-oauth2-credentials/' + organizationSid + '/' + authProvider + '/' + appName + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    createAppOAuth2Credentials(organizationSid:any, authProvider:any, appName:any, appOAuth2CredentialsCreateRequest:any):Promise<AppOAuth2CredentialsResponse>
    {
        const __responseTypeCtor = AppOAuth2CredentialsResponse;
        const __apiPath = '/api/app-oauth2-credentials/' + organizationSid + '/' + authProvider + '/' + appName + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, appOAuth2CredentialsCreateRequest);
    }

    getAppCredentials(organizationSid:any, authProvider:any, appName:any):Promise<AppOAuth2CredentialsResponse>
    {
        const __responseTypeCtor = AppOAuth2CredentialsResponse;
        const __apiPath = '/api/app-oauth2-credentials/' + organizationSid + '/' + authProvider + '/' + appName + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    updateAppOauth2Credentials(organizationSid:any, authProvider:any, appName:any, appOAuth2CredentialsUpdateRequest:any):Promise<AppOAuth2CredentialsResponse>
    {
        const __responseTypeCtor = AppOAuth2CredentialsResponse;
        const __apiPath = '/api/app-oauth2-credentials/' + organizationSid + '/' + authProvider + '/' + appName + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, appOAuth2CredentialsUpdateRequest);
    }

    listAppOauth2CredentialsByOrganization(organizationSid:any):Promise<AppOAuth2ListCredentialsResponse>
    {
        const __responseTypeCtor = AppOAuth2ListCredentialsResponse;
        const __apiPath = '/api/app-oauth2-credentials/' + organizationSid + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    listAppOauth2CredentialsByOrganizationAndProvider(organizationSid:any, authProvider:any):Promise<AppOAuth2ListCredentialsResponse>
    {
        const __responseTypeCtor = AppOAuth2ListCredentialsResponse;
        const __apiPath = '/api/app-oauth2-credentials/' + organizationSid + '/' + authProvider + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Application
{
    constructor(private _http:Fetcher)
    {
    }

    authenticate(applicationAuthRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/application/authenticate';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, applicationAuthRequest);
    }

    tokenSignIn(applicationTokenAuthRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/application/token-sign-in';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, applicationTokenAuthRequest);
    }

    checkAuth(checkAuthTokenRequest:any):Promise<CheckAuthResponse>
    {
        const __responseTypeCtor = CheckAuthResponse;
        const __apiPath = '/api/application/check-auth-token';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, checkAuthTokenRequest);
    }

    setVisualInput(setVisualDataApplicationRequest:any):Promise<BooleanResponse>
    {
        const __responseTypeCtor = BooleanResponse;
        const __apiPath = '/api/application/visual-data/set';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, setVisualDataApplicationRequest);
    }

    subscribe(userId:any, connectionId:any, publishedApplicationId:any, onmessage:any, onclose:any):Promise<EventSourceSubscriber>
    {
        const options = {onmessage: onmessage, onclose: onclose};
        const url = '/api/application/visual-data/subscribe?userId=' + userId + '&connectionId=' + connectionId + '&publishedApplicationId=' + publishedApplicationId;

        return new Promise((resolve:any, reject:any) =>
        {
            resolve(new EventSourceSubscriber(url, options));
        });
    }
}

export class Artifacts
{
    constructor(private _http:Fetcher)
    {
    }

    list(scope:any, id:any):Promise<GetDesignArtifactsResponse>
    {
        const __responseTypeCtor = GetDesignArtifactsResponse;
        const __apiPath = '/api/artifacts/' + scope + '/' + id + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    delete(scope:any, id:any, descriptor:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/artifacts/' + scope + '/' + id + '';
        const __params = {'descriptor': descriptor};
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, __params, null);
    }

    save(scope:any, id:any, artifactViewRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/artifacts/' + scope + '/' + id + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, artifactViewRequest);
    }

    set(scope:any, id:any, setDesignArtifactsRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/artifacts/' + scope + '/' + id + '/set';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, setDesignArtifactsRequest);
    }
}

export class Bases
{
    constructor(private _http:Fetcher)
    {
    }

    deleteBase(organizationSid:any, environmentName:any, baseName:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/bases/' + baseName + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    createBase(organizationSid:any, environmentName:any, baseName:any):Promise<BaseResponse>
    {
        const __responseTypeCtor = BaseResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/bases/' + baseName + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getBase(organizationSid:any, environmentName:any, baseName:any):Promise<BaseResponse>
    {
        const __responseTypeCtor = BaseResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/bases/' + baseName + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    renameBase(organizationSid:any, environmentName:any, baseName:any, baseRenameRequest:any):Promise<BaseResponse>
    {
        const __responseTypeCtor = BaseResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/bases/' + baseName + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, baseRenameRequest);
    }

    listBases(organizationSid:any, environmentName:any):Promise<BasesResponse>
    {
        const __responseTypeCtor = BasesResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/bases';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Billing
{
    constructor(private _http:Fetcher)
    {
    }

    getInvoiceHistory():Promise<InvoiceHistoryResponse>
    {
        const __responseTypeCtor = InvoiceHistoryResponse;
        const __apiPath = '/api/billing/invoice/history';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getCurrentPaymentMethod():Promise<PaymentMethodResponse>
    {
        const __responseTypeCtor = PaymentMethodResponse;
        const __apiPath = '/api/billing/payment-method';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    startSubscription(selectPlanRequest:any):Promise<SubscriptionResponse>
    {
        const __responseTypeCtor = SubscriptionResponse;
        const __apiPath = '/api/billing/subscriptions/start';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, selectPlanRequest);
    }

    getAllSubscriptions():Promise<SubscriptionsResponse>
    {
        const __responseTypeCtor = SubscriptionsResponse;
        const __apiPath = '/api/billing/subscriptions';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getProductOffering():Promise<ProductOffering>
    {
        const __responseTypeCtor = ProductOffering;
        const __apiPath = '/api/billing/';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    cancelSubscription(selectPlanRequest:any):Promise<BillingBooleanResponse>
    {
        const __responseTypeCtor = BillingBooleanResponse;
        const __apiPath = '/api/billing/subscriptions/cancel';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, selectPlanRequest);
    }

    hasPaymentMethod():Promise<BillingBooleanResponse>
    {
        const __responseTypeCtor = BillingBooleanResponse;
        const __apiPath = '/api/billing/has-payment-method';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class ComponentGroup
{
    constructor(private _http:Fetcher)
    {
    }

    add(addToLibraryRequest:any):Promise<DeployResult>
    {
        const __responseTypeCtor = DeployResult;
        const __apiPath = '/api/component-groups/addToLibrary';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, addToLibraryRequest);
    }
}

export class ComputePipe
{
    constructor(private _http:Fetcher)
    {
    }

    compute(computePipeRequest:any):Promise<ComputePipeResponse>
    {
        const __responseTypeCtor = ComputePipeResponse;
        const __apiPath = '/api/computePipe';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, computePipeRequest);
    }
}

export class Cortex
{
    constructor(private _http:Fetcher)
    {
    }

    assets(resource:any):Promise<String>
    {
        const __responseTypeCtor:any = null;
        const __apiPath = '/api/cortex/assets/' + resource + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    index():Promise<String>
    {
        const __responseTypeCtor:any = null;
        const __apiPath = '/api/cortex/ui';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class CurrentOrganization
{
    constructor(private _http:Fetcher)
    {
    }

    getAllUsers():Promise<UsersOfGroupsResponse>
    {
        const __responseTypeCtor = UsersOfGroupsResponse;
        const __apiPath = '/api/Current-organization/users';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class DesignSnapshots
{
    constructor(private _http:Fetcher)
    {
    }

    restore(projectId:any, designId:any, snapshotId:any):Promise<DesignResponse>
    {
        const __responseTypeCtor = DesignResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/snapshots/' + snapshotId + '/restore';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    get(projectId:any, designId:any, snapshotId:any):Promise<DesignSnapshotResponse>
    {
        const __responseTypeCtor = DesignSnapshotResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/snapshots/' + snapshotId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    list(projectId:any, designId:any):Promise<DesignSnapshotsResponse>
    {
        const __responseTypeCtor = DesignSnapshotsResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/snapshots/';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    listFunctions(projectId:any, designId:any, snapshotId:any):Promise<FunctionsResponse>
    {
        const __responseTypeCtor = FunctionsResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/snapshots/' + snapshotId + '/functions';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    create(projectId:any, designId:any, createDesignSnapshotRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/snapshots/';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, createDesignSnapshotRequest);
    }

    delete(projectId:any, designId:any, snapshotId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/snapshots/' + snapshotId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    update(projectId:any, designId:any, snapshotId:any, createDesignSnapshotRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/snapshots/' + snapshotId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, null, null, createDesignSnapshotRequest);
    }
}

export class Designs
{
    constructor(private _http:Fetcher)
    {
    }

    uploadCover(projectId:any, designId:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/cover';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    get(projectId:any, designId:any):Promise<DesignResponse>
    {
        const __responseTypeCtor = DesignResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    move(projectId:any, newProjectId:any, designId:any):Promise<DesignResponse>
    {
        const __responseTypeCtor = DesignResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/move/' + newProjectId + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    create(projectId:any, modifyDesignRequest:any):Promise<DesignResponse>
    {
        const __responseTypeCtor = DesignResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, modifyDesignRequest);
    }

    takeScreenshot(projectId:any, designId:any):Promise<DesignScreenshotResponse>
    {
        const __responseTypeCtor = DesignScreenshotResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/screenshot';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    copy(projectId:any, designId:any):Promise<DesignWithTimestampsResponse>
    {
        const __responseTypeCtor = DesignWithTimestampsResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/copy';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    list(projectId:any):Promise<DesignsResponse>
    {
        const __responseTypeCtor = DesignsResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getState(projectId:any, designId:any):Promise<LoadDesignResponse>
    {
        const __responseTypeCtor = LoadDesignResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/load';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    saveState(projectId:any, designId:any, saveDesignRequest:any):Promise<SaveDesignResponse>
    {
        const __responseTypeCtor = SaveDesignResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/save';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, saveDesignRequest);
    }

    getSettingsForEdit(projectId:any, designId:any, id:any):Promise<SettingsEditResponse>
    {
        const __responseTypeCtor = SettingsEditResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/settings/' + id + '/for-edit';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getSettingsList(projectId:any, designId:any):Promise<SettingsMetaListResponse>
    {
        const __responseTypeCtor = SettingsMetaListResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/settings-list';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    createSettings(projectId:any, designId:any, editSettingsRequest:any):Promise<SettingsResponse>
    {
        const __responseTypeCtor = SettingsResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/settings';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, editSettingsRequest);
    }

    getSettings(projectId:any, designId:any, id:any):Promise<SettingsResponse>
    {
        const __responseTypeCtor = SettingsResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/settings/' + id + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    updateSettings(projectId:any, designId:any, id:any, editSettingsRequest:any):Promise<SettingsResponse>
    {
        const __responseTypeCtor = SettingsResponse;
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/settings/' + id + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, editSettingsRequest);
    }

    backup(projectId:any, designId:any, backupRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/backup';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, backupRequest);
    }

    delete(projectId:any, designId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    deleteSettings(projectId:any, designId:any, id:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/settings/' + id + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    rename(projectId:any, designId:any, renameDesignRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/rename';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, renameDesignRequest);
    }

    reorder(projectId:any, designId:any, reorderDesignRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '/reorder';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, reorderDesignRequest);
    }

    update(projectId:any, designId:any, modifyDesignRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/designs/' + designId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, null, null, modifyDesignRequest);
    }
}

export class Excel
{
    constructor(private _http:Fetcher)
    {
    }

    parse(excelFileParseRequest:any):Promise<ParsedTabsResponse>
    {
        const __responseTypeCtor = ParsedTabsResponse;
        const __apiPath = '/api/excel/parse';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, excelFileParseRequest);
    }

    parseCsv(csvFileParseRequest:any):Promise<ParsedTabsResponse>
    {
        const __responseTypeCtor = ParsedTabsResponse;
        const __apiPath = '/api/excel/parsecsv';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, csvFileParseRequest);
    }

    upload():Promise<UploadedFileResponse>
    {
        const __responseTypeCtor = UploadedFileResponse;
        const __apiPath = '/api/excel/upload';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Features
{
    constructor(private _http:Fetcher)
    {
    }

    list():Promise<FeaturesResponse>
    {
        const __responseTypeCtor = FeaturesResponse;
        const __apiPath = '/api/settings/features';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    get(key:any):Promise<StringResponse>
    {
        const __responseTypeCtor = StringResponse;
        const __apiPath = '/api/settings/features/' + key + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    save(key:any, string:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/settings/features/' + key + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, string);
    }
}

export class Files
{
    constructor(private _http:Fetcher)
    {
    }

    getFile(organizationSid:any, fileId:any):Promise<FileResponse>
    {
        const __responseTypeCtor = FileResponse;
        const __apiPath = '/api/organization/' + organizationSid + '/files/' + fileId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getFiles(organizationSid:any, ids:any):Promise<FilesResponse>
    {
        const __responseTypeCtor = FilesResponse;
        const __apiPath = '/api/organization/' + organizationSid + '/files/';
        const __params = {'ids': ids};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    fetchAndSave(organizationSid:any, fetchFileRequest:any):Promise<FileResponse>
    {
        const __responseTypeCtor = FileResponse;
        const __apiPath = '/api/organization/' + organizationSid + '/files/fetch-and-save';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, fetchFileRequest);
    }

    fetchAndSaveMultiple(organizationSid:any, fetchFilesRequest:any):Promise<FilesResponse>
    {
        const __responseTypeCtor = FilesResponse;
        const __apiPath = '/api/organization/' + organizationSid + '/files/fetch-and-save-multiple';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, fetchFilesRequest);
    }
}

export class Functions
{
    constructor(private _http:Fetcher)
    {
    }

    importFunctions(designId:any, importFunctionsRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/designs/' + designId + '/functions/import';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, importFunctionsRequest);
    }

    create(designId:any, createFunctionRequest:any):Promise<FunctionSaveResponse>
    {
        const __responseTypeCtor = FunctionSaveResponse;
        const __apiPath = '/api/designs/' + designId + '/functions';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, createFunctionRequest);
    }

    save(designId:any, functionId:any, updateFunctionRequest:any):Promise<FunctionUpdateResponse>
    {
        const __responseTypeCtor = FunctionUpdateResponse;
        const __apiPath = '/api/designs/' + designId + '/functions/' + functionId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, updateFunctionRequest);
    }

    list(designId:any):Promise<FunctionsResponse>
    {
        const __responseTypeCtor = FunctionsResponse;
        const __apiPath = '/api/designs/' + designId + '/functions';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    delete(designId:any, functionId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/designs/' + designId + '/functions/' + functionId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }
}

export class Generate
{
    constructor(private _http:Fetcher)
    {
    }

    download(file:any, encrypt:any):Promise<Response>
    {
        const __apiPath = '/api/jar';
        const __params = {'file': file, 'encrypt': encrypt};
        const __method = 'get';

        return this._http.request(__method, __apiPath, null, __params, null);
    }

    generate(designDescription:any):Promise<GenerateResponse>
    {
        const __responseTypeCtor = GenerateResponse;
        const __apiPath = '/api/jar';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, designDescription);
    }
}

export class Insights
{
    constructor(private _http:Fetcher)
    {
    }

    loadMetricsTree(insightsRequest:any):Promise<InsightsResponse>
    {
        const __responseTypeCtor = InsightsResponse;
        const __apiPath = '/api/environment/insights-data';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, insightsRequest);
    }

    getStructure(environmentId:any, designId:any):Promise<InsightsTopologyView>
    {
        const __responseTypeCtor = InsightsTopologyView;
        const __apiPath = '/api/environment/' + environmentId + '/design/' + designId + '/insights-structure';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    isEnabled():Promise<BooleanResponse>
    {
        const __responseTypeCtor = BooleanResponse;
        const __apiPath = '/api/insights/enabled';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Invite
{
    constructor(private _http:Fetcher)
    {
    }

    requestInvitationResend(id:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/invite/' + id + '/requestNew';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    checkUserInvitation(code:any):Promise<CheckInviteCodeResponse>
    {
        const __responseTypeCtor = CheckInviteCodeResponse;
        const __apiPath = '/api/invite/check';
        const __params = {'code': code};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    getInvitationsForOrganizations():Promise<InvitationDetailsResponse>
    {
        const __responseTypeCtor = InvitationDetailsResponse;
        const __apiPath = '/api/invite/list';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    resendInvitation(id:any):Promise<InvitationDetailsResponse>
    {
        const __responseTypeCtor = InvitationDetailsResponse;
        const __apiPath = '/api/invite/' + id + '/resend';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    createInvitation(list:any):Promise<InviteCreationResponse>
    {
        const __responseTypeCtor = InviteCreationResponse;
        const __apiPath = '/api/invite/create';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, list);
    }

    join(joinRequest:any):Promise<ProfileResponse>
    {
        const __responseTypeCtor = ProfileResponse;
        const __apiPath = '/api/invite/join';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, joinRequest);
    }

    joinRegistered(joinRegisteredRequest:any):Promise<ProfileResponse>
    {
        const __responseTypeCtor = ProfileResponse;
        const __apiPath = '/api/invite/join-registered';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, joinRegisteredRequest);
    }

    deleteUserInvitation(id:any):Promise<DeleteInvitationResult>
    {
        const __responseTypeCtor = DeleteInvitationResult;
        const __apiPath = '/api/invite/' + id + '/delete';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Multiplayer
{
    constructor(private _http:Fetcher)
    {
    }

    resolve(projectId:any, designId:any):Promise<MultiplayerResolution>
    {
        const __responseTypeCtor = MultiplayerResolution;
        const __apiPath = '/api/multiplayer/' + projectId + '/designs/' + designId + '/resolve';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    bustCache(projectId:any, designId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/multiplayer/' + projectId + '/designs/' + designId + '/bust-cache';
        const __method = 'get';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    getInitEvent(projectId:any, designId:any, sessionId:any):Promise<InitEvent>
    {
        const __responseTypeCtor = InitEvent;
        const __apiPath = '/api/multiplayer/' + projectId + '/designs/' + designId + '/init-event/' + sessionId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Organizations
{
    constructor(private _http:Fetcher)
    {
    }

    isSidAlreadyExists(sid:any):Promise<String>
    {
        const __responseTypeCtor:any = null;
        const __apiPath = '/api/organizations/' + sid + '/exists';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    activeUsers(sid:any):Promise<ActiveUsersResponse>
    {
        const __responseTypeCtor = ActiveUsersResponse;
        const __apiPath = '/api/organizations/' + sid + '/active-users';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    generateSid():Promise<GenerateSidResponse>
    {
        const __responseTypeCtor = GenerateSidResponse;
        const __apiPath = '/api/organizations/generate-sid';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    createOrganization(modifyOrganizationRequest:any):Promise<OrganizationResponse>
    {
        const __responseTypeCtor = OrganizationResponse;
        const __apiPath = '/api/organizations/create';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, modifyOrganizationRequest);
    }

    updateOrganization(sid:any, modifyOrganizationRequest:any):Promise<OrganizationResponse>
    {
        const __responseTypeCtor = OrganizationResponse;
        const __apiPath = '/api/organizations/' + sid + '/update';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, modifyOrganizationRequest);
    }

    getOrganizations():Promise<OrganizationsResponse>
    {
        const __responseTypeCtor = OrganizationsResponse;
        const __apiPath = '/api/organizations';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getPublicOrganizations():Promise<OrganizationsResponse>
    {
        const __responseTypeCtor = OrganizationsResponse;
        const __apiPath = '/api/public-organizations';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    projectsList(sid:any):Promise<ProjectsResponse>
    {
        const __responseTypeCtor = ProjectsResponse;
        const __apiPath = '/api/organizations/' + sid + '/projects';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Profile
{
    constructor(private _http:Fetcher)
    {
    }

    logout():Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/logout';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    tokenSignUp(tokenSignUpRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/token-sign-up';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, tokenSignUpRequest);
    }

    uploadAvatar():Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/avatar';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    roles():Promise<MyRolesResponse>
    {
        const __responseTypeCtor = MyRolesResponse;
        const __apiPath = '/api/myroles';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    login(loginRequest:any):Promise<ProfileResponse>
    {
        const __responseTypeCtor = ProfileResponse;
        const __apiPath = '/api/login';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, loginRequest);
    }

    tokenSignIn(token:any):Promise<ProfileResponse>
    {
        const __responseTypeCtor = ProfileResponse;
        const __apiPath = '/api/token-sign-in';
        const __params = {'token': token};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    newPassword(newPasswordRequest:any):Promise<ProfileResponse>
    {
        const __responseTypeCtor = ProfileResponse;
        const __apiPath = '/api/new-password';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, newPasswordRequest);
    }

    register(registerRequest:any):Promise<ProfileResponse>
    {
        const __responseTypeCtor = ProfileResponse;
        const __apiPath = '/api/register';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, registerRequest);
    }

    editProfile(editProfileRequest:any):Promise<UserResponse>
    {
        const __responseTypeCtor = UserResponse;
        const __apiPath = '/api/edit-profile';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, editProfileRequest);
    }

    get():Promise<UserResponse>
    {
        const __responseTypeCtor = UserResponse;
        const __apiPath = '/api/profile';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    mdcCompatibleLogin(loginRequest:any):Promise<UserWithTokenResponse>
    {
        const __responseTypeCtor = UserWithTokenResponse;
        const __apiPath = '/api/auth/login';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, loginRequest);
    }

    checkEmail(e:any):Promise<CheckResponse>
    {
        const __responseTypeCtor = CheckResponse;
        const __apiPath = '/api/check/email';
        const __params = {'e': e};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    checkResetToken(token:any):Promise<CheckResponse>
    {
        const __responseTypeCtor = CheckResponse;
        const __apiPath = '/api/check/token';
        const __params = {'token': token};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    checkUsername(u:any):Promise<CheckResponse>
    {
        const __responseTypeCtor = CheckResponse;
        const __apiPath = '/api/check/username';
        const __params = {'u': u};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    changePassword(changePasswordRequest:any):Promise<TokenResponse>
    {
        const __responseTypeCtor = TokenResponse;
        const __apiPath = '/api/change-password';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, changePasswordRequest);
    }

    changeName(changeNameRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/change-name';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, changeNameRequest);
    }

    resetPassword(resetPasswordEmailRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/reset-password';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, resetPasswordEmailRequest);
    }
}

export class Projects
{
    constructor(private _http:Fetcher)
    {
    }

    getAvailableRoles(projectId:any):Promise<RolesResponse>
    {
        const __responseTypeCtor = RolesResponse;
        const __apiPath = '/api/projects/' + projectId + '/available-roles';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    get(projectId:any):Promise<ProjectResponse>
    {
        const __responseTypeCtor = ProjectResponse;
        const __apiPath = '/api/projects/' + projectId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    create(modifyProjectRequest:any):Promise<ProjectResponse>
    {
        const __responseTypeCtor = ProjectResponse;
        const __apiPath = '/api/projects';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, modifyProjectRequest);
    }

    roles(projectId:any):Promise<ProjectRolesResponse>
    {
        const __responseTypeCtor = ProjectRolesResponse;
        const __apiPath = '/api/projects/' + projectId + '/myroles';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getUsers(projectId:any):Promise<ProjectUsersResponse>
    {
        const __responseTypeCtor = ProjectUsersResponse;
        const __apiPath = '/api/projects/' + projectId + '/users';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    list():Promise<ProjectsResponse>
    {
        const __responseTypeCtor = ProjectsResponse;
        const __apiPath = '/api/projects';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    delete(projectId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    update(projectId:any, modifyProjectRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, null, null, modifyProjectRequest);
    }
}

export class Proxy
{
    constructor(private _http:Fetcher)
    {
    }

    proxyApiRequest(authProvider:any, organizationSid:any, appName:any, proxyRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/fetch/' + authProvider + '/' + organizationSid + '/' + appName + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, proxyRequest);
    }

    proxyRequest(proxyRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/fetch';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, proxyRequest);
    }
}

export class Publish
{
    constructor(private _http:Fetcher)
    {
    }

    checkCustomerCNameMapping(checkCustomerCNameRequest:any):Promise<CNameMappingResponse>
    {
        const __responseTypeCtor = CNameMappingResponse;
        const __apiPath = '/api/publish/check-customer-cname-mapping';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, checkCustomerCNameRequest);
    }

    checkOurCNameProgress(checkOurCNameProgress:any):Promise<CNameMappingResponse>
    {
        const __responseTypeCtor = CNameMappingResponse;
        const __apiPath = '/api/publish/check-our-cname-progress';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, checkOurCNameProgress);
    }

    getPublish(publishedApplicationId:any):Promise<PublishedApplicationResponse>
    {
        const __responseTypeCtor = PublishedApplicationResponse;
        const __apiPath = '/api/publish/' + publishedApplicationId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    unpublish(publishedApplicationId:any):Promise<PublishedApplicationResponse>
    {
        const __responseTypeCtor = PublishedApplicationResponse;
        const __apiPath = '/api/publish/' + publishedApplicationId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    updatePublish(publishedApplicationId:any, updatePublishRequest:any):Promise<PublishedDesignResponse>
    {
        const __responseTypeCtor = PublishedDesignResponse;
        const __apiPath = '/api/publish/' + publishedApplicationId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, updatePublishRequest);
    }

    list(projectId:any):Promise<PublishedDesignsResponse>
    {
        const __responseTypeCtor = PublishedDesignsResponse;
        const __apiPath = '/api/publish';
        const __params = {'projectId': projectId};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    listPublished():Promise<PublishedDesignsResponse>
    {
        const __responseTypeCtor = PublishedDesignsResponse;
        const __apiPath = '/api/publish/published';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    suggestUrlPart(designId:any):Promise<SuggestUrlPartResponse>
    {
        const __responseTypeCtor = SuggestUrlPartResponse;
        const __apiPath = '/api/publish/suggest-url-part';
        const __params = {'designId': designId};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    startPublishedApp(publishedApplicationId:any):Promise<UpdateAppStatusResponse>
    {
        const __responseTypeCtor = UpdateAppStatusResponse;
        const __apiPath = '/api/publish/' + publishedApplicationId + '/start';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    stopPublishedApp(publishedApplicationId:any):Promise<UpdateAppStatusResponse>
    {
        const __responseTypeCtor = UpdateAppStatusResponse;
        const __apiPath = '/api/publish/' + publishedApplicationId + '/stop';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    checkUrlPart(urlPart:any, designId:any, isBeta:any):Promise<CheckResponse>
    {
        const __responseTypeCtor = CheckResponse;
        const __apiPath = '/api/publish/check-url-part';
        const __params = {'urlPart': urlPart, 'designId': designId, 'isBeta': isBeta};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    publish(publishRequest:any):Promise<PublishedApplicationResponse>
    {
        const __responseTypeCtor = PublishedApplicationResponse;
        const __apiPath = '/api/publish';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, publishRequest);
    }

    standaloneZip(designId:any, full:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/publish/standalone-zip/' + designId + '';
        const __params = {'full': full};
        const __method = 'get';

        return this._http.request(__method, __apiPath, null, __params, null);
    }
}

export class Resolution
{
    constructor(private _http:Fetcher)
    {
    }

    resolve(resolutionRequest:any):Promise<ResolutionResponse>
    {
        const __responseTypeCtor = ResolutionResponse;
        const __apiPath = '/api/resolution';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, resolutionRequest);
    }

    searchComponentSets(n:any):Promise<CloudArtifactsResponse>
    {
        const __responseTypeCtor = CloudArtifactsResponse;
        const __apiPath = '/api/resolution/repositories/search';
        const __params = {'n': n};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }
}

export class Roles
{
    constructor(private _http:Fetcher)
    {
    }

    getPermissions(projectId:any, roleId:any):Promise<PermissionsResponse>
    {
        const __responseTypeCtor = PermissionsResponse;
        const __apiPath = '/api/roles/' + roleId + '/permissions';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    addPermission(projectId:any, roleId:any, modifyPermissionRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/roles/' + roleId + '/permissions';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, modifyPermissionRequest);
    }

    removePermission(projectId:any, roleId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/roles/' + roleId + '/permissions';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }
}

export class Root
{
    constructor(private _http:Fetcher)
    {
    }

    getRobots():Promise<String>
    {
        const __responseTypeCtor:any = null;
        const __apiPath = '/robots.txt';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Rows
{
    constructor(private _http:Fetcher)
    {
    }

    addRows(organizationSid:any, environmentName:any, baseName:any, tableName:any, rowsAddRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/rows/' + baseName + '/' + tableName + '/add';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, rowsAddRequest);
    }

    deleteRowsByIds(organizationSid:any, environmentName:any, baseName:any, tableName:any, rowsDeleteByIdsRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/rows/' + baseName + '/' + tableName + '/delete-by-ids';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, rowsDeleteByIdsRequest);
    }

    deleteRowsByQuery(organizationSid:any, environmentName:any, baseName:any, tableName:any, rowsQueryRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/rows/' + baseName + '/' + tableName + '/delete-by-query';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, rowsQueryRequest);
    }

    updateRowsByIds(organizationSid:any, environmentName:any, baseName:any, tableName:any, rowsUpdateByIdsRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/rows/' + baseName + '/' + tableName + '/update-by-ids';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, rowsUpdateByIdsRequest);
    }

    updateRowsByQuery(organizationSid:any, environmentName:any, baseName:any, tableName:any, rowsUpdateByQueryRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/rows/' + baseName + '/' + tableName + '/update-by-query';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, rowsUpdateByQueryRequest);
    }

    upsertRows(organizationSid:any, environmentName:any, baseName:any, tableName:any, rowsUpsertRequest:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/rows/' + baseName + '/' + tableName + '/upsert';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, rowsUpsertRequest);
    }

    countRows(organizationSid:any, environmentName:any, baseName:any, tableName:any, rowsQueryRequest:any):Promise<RowsCountResponse>
    {
        const __responseTypeCtor = RowsCountResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/rows/' + baseName + '/' + tableName + '/count';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, rowsQueryRequest);
    }

    selectRows(organizationSid:any, environmentName:any, baseName:any, tableName:any, rowsSelectRequest:any):Promise<RowsSelectResponse>
    {
        const __responseTypeCtor = RowsSelectResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/rows/' + baseName + '/' + tableName + '/select';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, rowsSelectRequest);
    }
}

export class S3Upload
{
    constructor(private _http:Fetcher)
    {
    }

    getRepositories(s3Request:any):Promise<S3BucketsResponse>
    {
        const __responseTypeCtor = S3BucketsResponse;
        const __apiPath = '/api/s3jar/buckets';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, s3Request);
    }

    upload(s3UploadRequest:any):Promise<S3UploadResponse>
    {
        const __responseTypeCtor = S3UploadResponse;
        const __apiPath = '/api/s3jar';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, s3UploadRequest);
    }
}

export class Sample
{
    constructor(private _http:Fetcher)
    {
    }

    openSampleDesign(designId:any):Promise<Design>
    {
        const __responseTypeCtor = Design;
        const __apiPath = '/api/sample/open/' + designId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    designVersionsList(designId:any, names:any):Promise<DesignSnapshotsResponse>
    {
        const __responseTypeCtor = DesignSnapshotsResponse;
        const __apiPath = '/api/sample/design/' + designId + '/versions';
        const __params = {'names': names};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }

    sampleFunctionsList(designId:any):Promise<FunctionsResponse>
    {
        const __responseTypeCtor = FunctionsResponse;
        const __apiPath = '/api/sample/functions/' + designId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    copySampleToCompanyWorkspace(deployedDesignId:any):Promise<SampleDesignResponse>
    {
        const __responseTypeCtor = SampleDesignResponse;
        const __apiPath = '/api/sample/copy/' + deployedDesignId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    grabSampleDesign(sampleDesignId:any, grabDesignRequest:any):Promise<SampleDesignResponse>
    {
        const __responseTypeCtor = SampleDesignResponse;
        const __apiPath = '/api/sample/grab/' + sampleDesignId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, grabDesignRequest);
    }
}

export class SearchCatalog
{
    constructor(private _http:Fetcher)
    {
    }

    getComponents(request:any):Promise<GetComponentsResponse>
    {
        const __responseTypeCtor = GetComponentsResponse;
        const __apiPath = '/api/search/catalog/components';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, request);
    }

    getAllPackages():Promise<GetPackagesResponse>
    {
        const __responseTypeCtor = GetPackagesResponse;
        const __apiPath = '/api/search/catalog/get-all-packages';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getPackages(request:any):Promise<GetPackagesResponse>
    {
        const __responseTypeCtor = GetPackagesResponse;
        const __apiPath = '/api/search/catalog/packages';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, request);
    }
}

export class Simulation
{
    constructor(private _http:Fetcher)
    {
    }

    start(startSimulationRequest:any):Promise<SimulationResponse>
    {
        const __responseTypeCtor = SimulationResponse;
        const __apiPath = '/api/simulation/start';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, startSimulationRequest);
    }

    stop(stopSimulationRequest:any):Promise<SimulationResponse>
    {
        const __responseTypeCtor = SimulationResponse;
        const __apiPath = '/api/simulation/stop';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, stopSimulationRequest);
    }

    getTopologyId():Promise<TopologyIdResponse>
    {
        const __responseTypeCtor = TopologyIdResponse;
        const __apiPath = '/api/simulation/topologyId';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    validate(designDescription:any):Promise<ValidationResponse>
    {
        const __responseTypeCtor = ValidationResponse;
        const __apiPath = '/api/simulation/validate';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, designDescription);
    }

    setVisualInput(setVisualDataSimulationRequest:any):Promise<BooleanResponse>
    {
        const __responseTypeCtor = BooleanResponse;
        const __apiPath = '/api/simulation/visual-data/set';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, setVisualDataSimulationRequest);
    }

    subscribe(topologyId:any, userId:any, connectionId:any, onmessage:any, onclose:any):Promise<EventSourceSubscriber>
    {
        const options = {onmessage: onmessage, onclose: onclose};
        const url = '/api/simulation/subscribe?topologyId=' + topologyId + '&userId=' + userId + '&connectionId=' + connectionId;

        return new Promise((resolve:any, reject:any) =>
        {
            resolve(new EventSourceSubscriber(url, options));
        });
    }
}

export class Snippets
{
    constructor(private _http:Fetcher)
    {
    }

    delete(snippetId:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/snippets/' + snippetId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    create(createEmbedSnippetRequest:any):Promise<EmbedSnippetResponse>
    {
        const __responseTypeCtor = EmbedSnippetResponse;
        const __apiPath = '/api/snippets';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, createEmbedSnippetRequest);
    }

    get(snippetId:any):Promise<EmbedSnippetResponse>
    {
        const __responseTypeCtor = EmbedSnippetResponse;
        const __apiPath = '/api/snippets/' + snippetId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    update(snippetId:any, modifyEmbedSnippetRequest:any):Promise<EmbedSnippetResponse>
    {
        const __responseTypeCtor = EmbedSnippetResponse;
        const __apiPath = '/api/snippets/' + snippetId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, modifyEmbedSnippetRequest);
    }

    list():Promise<EmbedSnippetsResponse>
    {
        const __responseTypeCtor = EmbedSnippetsResponse;
        const __apiPath = '/api/snippets';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class StaticDesignAssets
{
    constructor(private _http:Fetcher)
    {
    }

    getArtifactAsset(artifactDescriptor:any, asset:any):Promise<Response>
    {
        const __apiPath = '/api/static/artifacts/' + artifactDescriptor + '/assets/' + asset + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    getArtifactBundleJs(artifactDescriptor:any):Promise<Response>
    {
        const __apiPath = '/api/static/artifacts/' + artifactDescriptor + '/bundle.js';
        const __method = 'get';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    getDashboardAsset(deployDesignId:any, artifactDescriptor:any, asset:any):Promise<Response>
    {
        const __apiPath = '/api/static/dashboards/' + deployDesignId + '/assets/' + artifactDescriptor + '/' + asset + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    getDashboardBundleJs(deployDesignId:any):Promise<Response>
    {
        const __apiPath = '/api/static/dashboards/' + deployDesignId + '/bundle.js';
        const __method = 'get';

        return this._http.request(__method, __apiPath, null, null, null);
    }
}

export class SwaggerUi
{
    constructor(private _http:Fetcher)
    {
    }

    getFile(path:any):Promise<InputStream>
    {
        const __responseTypeCtor = InputStream;
        const __apiPath = '/api/swagger-ui/' + path + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getOpenApi(type:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/openapi.' + type + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Tables
{
    constructor(private _http:Fetcher)
    {
    }

    deleteTable(organizationSid:any, environmentName:any, baseName:any, tableName:any):Promise<Response>
    {
        const __responseTypeCtor = Response;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/tables/' + baseName + '/' + tableName + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    renameTable(organizationSid:any, environmentName:any, baseName:any, tableName:any, tableRenameRequest:any):Promise<TableResponse>
    {
        const __responseTypeCtor = TableResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/tables/' + baseName + '/' + tableName + '/rename';
        const __method = 'put';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, tableRenameRequest);
    }

    getTableSchema(organizationSid:any, environmentName:any, baseName:any, tableName:any):Promise<TableSchemaResponse>
    {
        const __responseTypeCtor = TableSchemaResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/tables/' + baseName + '/' + tableName + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    specTable(organizationSid:any, environmentName:any, baseName:any, tableName:any, tableSpecRequest:any):Promise<TableSchemaResponse>
    {
        const __responseTypeCtor = TableSchemaResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/tables/' + baseName + '/' + tableName + '';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, tableSpecRequest);
    }

    listTablesByBase(organizationSid:any, environmentName:any, baseName:any):Promise<TablesResponse>
    {
        const __responseTypeCtor = TablesResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/tables/' + baseName + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    listTablesByEnvironment(organizationSid:any, environmentName:any):Promise<TablesResponse>
    {
        const __responseTypeCtor = TablesResponse;
        const __apiPath = '/api/data/' + organizationSid + '/' + environmentName + '/tables';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class Teams
{
    constructor(private _http:Fetcher)
    {
    }

    getExtendedTeams(projectId:any):Promise<ExtendedTeamsResponse>
    {
        const __responseTypeCtor = ExtendedTeamsResponse;
        const __apiPath = '/api/projects/' + projectId + '/teams/extended';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    getRoles(projectId:any, teamId:any):Promise<RolesResponse>
    {
        const __responseTypeCtor = RolesResponse;
        const __apiPath = '/api/projects/' + projectId + '/teams/' + teamId + '/roles';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    get(projectId:any, teamId:any):Promise<TeamResponse>
    {
        const __responseTypeCtor = TeamResponse;
        const __apiPath = '/api/projects/' + projectId + '/teams/' + teamId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    create(projectId:any, createTeamRequest:any):Promise<TeamResponse>
    {
        const __responseTypeCtor = TeamResponse;
        const __apiPath = '/api/projects/' + projectId + '/teams';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, createTeamRequest);
    }

    getUsers(projectId:any, teamId:any):Promise<TeamUsersResponse>
    {
        const __responseTypeCtor = TeamUsersResponse;
        const __apiPath = '/api/projects/' + projectId + '/teams/' + teamId + '/users';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    list(projectId:any):Promise<TeamsResponse>
    {
        const __responseTypeCtor = TeamsResponse;
        const __apiPath = '/api/projects/' + projectId + '/teams';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    addRole(projectId:any, teamId:any, addRoleToProjectRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/teams/' + teamId + '/roles';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, addRoleToProjectRequest);
    }

    delete(projectId:any, teamId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/teams/' + teamId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    removeRole(projectId:any, teamId:any, roleId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/teams/' + teamId + '/roles/' + roleId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    setRole(projectId:any, teamId:any, roleId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/teams/' + teamId + '/role/' + roleId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    update(projectId:any, teamId:any, modifyTeamRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/teams/' + teamId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, null, null, modifyTeamRequest);
    }

    addUser(projectId:any, manageTeamUserRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/teams/add-user';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, manageTeamUserRequest);
    }

    removeUser(projectId:any, manageTeamUserRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/projects/' + projectId + '/teams/remove-user';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, manageTeamUserRequest);
    }
}

export class UserGroups
{
    constructor(private _http:Fetcher)
    {
    }

    getRole(groupId:any):Promise<RoleResponse>
    {
        const __responseTypeCtor = RoleResponse;
        const __apiPath = '/api/user-groups/' + groupId + '/role';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    extended():Promise<ExtendedUserGroupsResponse>
    {
        const __responseTypeCtor = ExtendedUserGroupsResponse;
        const __apiPath = '/api/user-groups/extended';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    get(groupId:any):Promise<UserGroupResponse>
    {
        const __responseTypeCtor = UserGroupResponse;
        const __apiPath = '/api/user-groups/' + groupId + '';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    create(createUserGroupRequest:any):Promise<UserGroupResponse>
    {
        const __responseTypeCtor = UserGroupResponse;
        const __apiPath = '/api/user-groups';
        const __method = 'post';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, createUserGroupRequest);
    }

    getUsers(groupId:any):Promise<UserGroupUsersResponse>
    {
        const __responseTypeCtor = UserGroupUsersResponse;
        const __apiPath = '/api/user-groups/' + groupId + '/users';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    list():Promise<UserGroupsResponse>
    {
        const __responseTypeCtor = UserGroupsResponse;
        const __apiPath = '/api/user-groups';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }

    addUsers(groupId:any, manageUserGroupUsersRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/user-groups/' + groupId + '/add-users';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, manageUserGroupUsersRequest);
    }

    delete(groupId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/user-groups/' + groupId + '';
        const __method = 'delete';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    removeUsers(groupId:any, manageUserGroupUsersRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/user-groups/' + groupId + '/remove-users';
        const __method = 'post';

        return this._http.request(__method, __apiPath, null, null, manageUserGroupUsersRequest);
    }

    setRole(groupId:any, roleId:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/user-groups/' + groupId + '/role/' + roleId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, null, null, null);
    }

    update(groupId:any, modifyGroupRequest:any):Promise<NoExpectedResponse>
    {
        const __apiPath = '/api/user-groups/' + groupId + '';
        const __method = 'put';

        return this._http.request(__method, __apiPath, null, null, modifyGroupRequest);
    }
}

export class Users
{
    constructor(private _http:Fetcher)
    {
    }

    find(q:any):Promise<FindUsersResponse>
    {
        const __responseTypeCtor = FindUsersResponse;
        const __apiPath = '/api/users/search';
        const __params = {'q': q};
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, __params, null);
    }
}

export class Version
{
    constructor(private _http:Fetcher)
    {
    }

    getVersion():Promise<String>
    {
        const __responseTypeCtor:any = null;
        const __apiPath = '/api/version';
        const __method = 'get';

        return this._http.request(__method, __apiPath, __responseTypeCtor, null, null);
    }
}

export class WspAPI
{
    public readonly standardArtifacts:StandardArtifacts;
    public readonly appOauth2:AppOauth2;
    public readonly appOauth2Credentials:AppOauth2Credentials;
    public readonly application:Application;
    public readonly artifacts:Artifacts;
    public readonly bases:Bases;
    public readonly billing:Billing;
    public readonly componentGroup:ComponentGroup;
    public readonly computePipe:ComputePipe;
    public readonly cortex:Cortex;
    public readonly currentOrganization:CurrentOrganization;
    public readonly designSnapshots:DesignSnapshots;
    public readonly designs:Designs;
    public readonly excel:Excel;
    public readonly features:Features;
    public readonly files:Files;
    public readonly functions:Functions;
    public readonly generate:Generate;
    public readonly insights:Insights;
    public readonly invite:Invite;
    public readonly multiplayer:Multiplayer;
    public readonly organizations:Organizations;
    public readonly profile:Profile;
    public readonly projects:Projects;
    public readonly proxy:Proxy;
    public readonly publish:Publish;
    public readonly resolution:Resolution;
    public readonly roles:Roles;
    public readonly root:Root;
    public readonly rows:Rows;
    public readonly s3Upload:S3Upload;
    public readonly sample:Sample;
    public readonly searchCatalog:SearchCatalog;
    public readonly simulation:Simulation;
    public readonly snippets:Snippets;
    public readonly staticDesignAssets:StaticDesignAssets;
    public readonly swaggerUi:SwaggerUi;
    public readonly tables:Tables;
    public readonly teams:Teams;
    public readonly userGroups:UserGroups;
    public readonly users:Users;
    public readonly version:Version;

    constructor(http:Fetcher)
    {
        this.standardArtifacts = new StandardArtifacts(http);
        this.appOauth2 = new AppOauth2(http);
        this.appOauth2Credentials = new AppOauth2Credentials(http);
        this.application = new Application(http);
        this.artifacts = new Artifacts(http);
        this.bases = new Bases(http);
        this.billing = new Billing(http);
        this.componentGroup = new ComponentGroup(http);
        this.computePipe = new ComputePipe(http);
        this.cortex = new Cortex(http);
        this.currentOrganization = new CurrentOrganization(http);
        this.designSnapshots = new DesignSnapshots(http);
        this.designs = new Designs(http);
        this.excel = new Excel(http);
        this.features = new Features(http);
        this.files = new Files(http);
        this.functions = new Functions(http);
        this.generate = new Generate(http);
        this.insights = new Insights(http);
        this.invite = new Invite(http);
        this.multiplayer = new Multiplayer(http);
        this.organizations = new Organizations(http);
        this.profile = new Profile(http);
        this.projects = new Projects(http);
        this.proxy = new Proxy(http);
        this.publish = new Publish(http);
        this.resolution = new Resolution(http);
        this.roles = new Roles(http);
        this.root = new Root(http);
        this.rows = new Rows(http);
        this.s3Upload = new S3Upload(http);
        this.sample = new Sample(http);
        this.searchCatalog = new SearchCatalog(http);
        this.simulation = new Simulation(http);
        this.snippets = new Snippets(http);
        this.staticDesignAssets = new StaticDesignAssets(http);
        this.swaggerUi = new SwaggerUi(http);
        this.tables = new Tables(http);
        this.teams = new Teams(http);
        this.userGroups = new UserGroups(http);
        this.users = new Users(http);
        this.version = new Version(http);
    }
}
